(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("react-dom/client"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "react-dom/client"], factory);
	else if(typeof exports === 'object')
		exports["rsuite"] = factory(require("react"), require("react-dom"), require("react-dom/client"));
	else
		root["rsuite"] = factory(root["React"], root["ReactDOM"], root["ReactDOM"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__15442__, __WEBPACK_EXTERNAL_MODULE__56003__, __WEBPACK_EXTERNAL_MODULE__13105__) {
return 